<template>
  <ActionIcon
    v-if="permission.canImpersonateUser"
    :action-fn="onImpersonateClick"
    :label="$t('estate.log-in-user')"
    icon="single-neutral-actions-full"
    :data-e2e="SpotlightCypressAttribute.buttons.IMPERSONATE"
  />
</template>

<script>
import ActionIcon from '@/modules/core/app/components/ActionIcon.vue';
import { HasPermissionMixin } from '@/modules/core/app/mixins/HasPermissionMixin';
import { ImpersonateUserModalMixin } from '@/modules/ops/components/mixins/ImpersonateUserModalMixin';
import { SpotlightCypressAttribute } from '@/modules/spotlight/constants/SpotlightCypressAttribute';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightEstateImpersonateUserAction',
  mixins: [HasPermissionMixin, ImpersonateUserModalMixin],
  components: {
    ActionIcon
  },
  static: {
    SpotlightCypressAttribute
  }
};
</script>
